<template>
  <div class="warehouse-profile-page warehouse-profile-page--edit">

    <div class="warehouse-page-heading">
      <div class="warehouse-page-heading__icon" aria-hidden="true"><i class="fas fa-edit"></i></div>
      <div><span>Manajemen inventori</span><h1>Ubah gudang</h1><p>Perbarui informasi gudang dan susunan rak penyimpanan.</p></div>
    </div>

    <!-- Main Row -->
    <div class="row">

      <!-- Form -->
      <div class="col-md-12">
        <Card :card-class="'warehouse-profile-card'">
          <template
            v-slot:body
            v-if="dataLoaded"
          >
            <Form
              :form="form"
              purpose="edit"
              :route="'warehouses/' + form.id"
            />
          </template>
        </Card>
      </div>

    </div>

  </div>
</template>

<script>

import Card from "@/view/content/Card.vue"
import Form from '@/component/masters/warehouses/Form.vue'
import module from '@/core/modules/CrudModule.js'
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module"

export default {

  components: {
    Card,
    Form
  },

  data() {
    return {
      // Form
      form: {
        name: "",
        address: "",
        description: "",
      },
      // Other
      dataLoaded: false
    }
  },

  methods: {

    async get() {
      this.form = await module.get('warehouses/' + this.$route.params.id)
      // If Data Not Found
      if (this.form == null) {
        // Redirect To List
        this.$router.push('/masters/warehouses/list')
      } else {
        this.form['_method'] = 'put'
        this.dataLoaded = true
      }
    }

  },

  mounted() {
    // BreadCrumb
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Gudang", route: "" },
      { title: "Daftar Gudang", route: "/masters/warehouses/list" },
      { title: "Ubah" },
    ])
    // Get Data
    this.get()
  },

}

</script>
<style lang="scss" src="@/assets/sass/pages/_warehouse-profile-pages.scss"></style>
